import { any, func } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import FormCreator from "../../common/FormCreator";
import history from "../../history";
import { postDrivingForm } from "../../redux/actions";
import HorizontalLine from "../../common/HorizontalLine";

const LicenceDetailsAndDvlaCheck = ({ appData, postDrivingFormFunc }) => {
  const initialName = `${appData.firstName} ${appData.lastName}`;
  const initialData = {
    firstName: appData.firstName,
    surname: appData.lastName,
    title: appData.title,
    dvlaCheck: {
      ADR: {},
      "Lorry Loader": {},
      MOFFET: {},
      "MPQC/EPIC": {},
    },
    drivingLicenceCheckingConsent: initialName,
    printName: initialName,
    dated: moment().format("DD/MM/YYYY"),
    signed: initialName,
    ...(appData.drivingOnboarding &&
      appData.drivingOnboarding.licenceDetailsAndDvlaCheck),
  };
  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";

  const getVal = getField(initialData);

  const classes = {
    b: "B",
    c1: "C1",
    c: "C",
    ce: "CE",
    d1: "D1",
    d: "D",
    other: "Other",
  };

  const initialState = {
    licenceDetails: {
      htmlObj: <HorizontalLine text="Licence details" />,
    },
    firstName: {
      title: "First name",
      value: getVal("firstName"),
      mandatory: true,
    },
    surname: {
      title: "Surname",
      value: getVal("surname"),
      mandatory: true,
    },
    title: {
      title: "Title",
      value: getVal("title"),
    },
    classHeld: {
      title: "Class held",
      value: getVal("classHeld"),
      type: "multivalueCheckbox",
      selectOptions: [
        { label: classes.b, value: classes.b },
        { label: classes.c1, value: classes.c1 },
        { label: classes.c, value: classes.c },
        { label: classes.ce, value: classes.ce },
        { label: classes.d1, value: classes.d1 },
        { label: classes.d, value: classes.d },
        { label: classes.other, value: classes.other },
      ],
    },
    otherClass: {
      title: "Other class",
      value: getVal("otherClass"),
      dependOn: [
        {
          fieldKey: "classHeld",
          allowedValues: [classes.other],
        },
      ],
    },
    licenceNumber: {
      title: "Licence number",
      value: getVal("licenceNumber"),
    },
    passDateHGV: {
      title: "Pass date HGV",
      value: getVal("passDateHGV"),
    },
    datePassedTest: {
      title: "Date passed car driving test",
      value: getVal("datePassedTest"),
    },
    endorsements: {
      title: "Endorsements (Please specify code and date)",
      value: getVal("endorsements"),
    },
    specialCertificates: {
      title: "Special certificates",
      value: getVal("specialCertificates"),
    },
    dvlaCheck: {
      value: getVal("dvlaCheck"),
      type: "table",
      tableDetails: {
        columns: ["Type", "Certificate issued by", "Expiry date"],
        rows: ["ADR", "Lorry Loader", "MOFFET", "MPQC/EPIC"],
        collapsableOnMobile: true,
      },
    },
    dvlaCheckAndSignature: {
      htmlObj: <HorizontalLine text="DVLA check and signature" />,
    },
    drivingLicenceCheckingConsent: {
      value: getVal("drivingLicenceCheckingConsent"),
      // eslint-disable-next-line react/display-name
      template: (input) => (
        <div className="text-justify">
          <p>
            I {input} hereby consent to HRGO Recruitment Driving Division
            checking my driving licence by using the online checking service
            provided by the DVLA at any time during my period of service with HR
            GO Recruitment.
          </p>
          <p>
            As part of the procedure I agree that HRGO Recruitment may supply
            the DVLA with my postcode, National Insurance number, Driving
            Licence number and conduct licence checks.
          </p>
          <p>
            I understand that this consent will be terminated in the event that
            my service with HRGO Recruitment is terminated by either party.
          </p>
        </div>
      ),
    },
    printName: {
      title: "Print name",
      value: getVal("printName"),
      mandatory: true,
    },
    dated: {
      title: "Dated",
      value: getVal("dated"),
      mandatory: true,
    },
    signed: {
      title: "Signed",
      value: getVal("signed"),
      mandatory: true,
    },
  };

  const [fields, setField] = useForm(initialState);
  const handleSubmit = () => {
    postDrivingFormFunc(
      "licenceDetailsAndDvlaCheck",
      formCreatorConvertToValues(fields)
    );
    history.push("/profile/edit/driving-onboarding");
  };
  return (
    <FormCreator
      formTitle={"Licence Details & DVLA Check"}
      fields={fields}
      setField={setField}
      onboardingBranch="driving"
      handleSubmit={handleSubmit}
      handleCancel={() => history.push("/profile/edit/driving-onboarding")}
    />
  );
};

LicenceDetailsAndDvlaCheck.propTypes = {
  appData: any,
  postDrivingFormFunc: func.isRequired,
};
const mapDispatchToProps = {
  postDrivingFormFunc: postDrivingForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(LicenceDetailsAndDvlaCheck);
